export default __webpack_public_path__ + "static/media/DECLARACAO_RESIDENCIA_(002).28fbe1f2.pdf";